import { render, staticRenderFns } from "./BarcodeManufacturers.vue?vue&type=template&id=700ac064"
import script from "./BarcodeManufacturers.vue?vue&type=script&lang=ts"
export * from "./BarcodeManufacturers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports